"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwError = exports.logError = void 0;
function logError(msg) {
    console.error("[SimpleHttp]: ".concat(msg));
}
exports.logError = logError;
function throwError(msg) {
    throw new Error("[SimpleHttp]: ".concat(msg));
}
exports.throwError = throwError;
